import React from "react";
import {Badge, DataTableColumnProps, Icon} from "peggirkit";
import {FormattedMessage, IntlShape} from "react-intl";
import {FeaturedProductDetails, ProductReference} from "@/data/entities/product";
import DescriptionFormatter from "@widgets/featuredProducts/overview/table/DescriptionFormatter";
import BadgeIconIndicator from "peggirkit/dist/components/Badge/BadgeElements/Indicator/BadgeIconIndicator";
import {ExclamationCircleIcon} from "@heroicons/react/16/solid";
import OptionsFormatter from "@widgets/featuredProducts/overview/table/OptionsFormatter";
import {Bars4Icon} from "@heroicons/react/24/solid";
import {DeleteFeaturedProductState} from "@widgets/featuredProducts/delete/DeleteFeaturedProductModal";
import {SetStateFn} from "@/utils/SetStateUtils";

export const getFeaturedProductsTableColumns = (
    intl: IntlShape,
    deleteFeaturedProductState: SetStateFn<DeleteFeaturedProductState>,
): DataTableColumnProps<FeaturedProductDetails>[] => ([
    {
        id: "id",
        label: {
            displayName: intl.formatMessage({id: "id"}),
            hide: true,
        },
        primary: false,
        tdClassname: "w-5",
        thClassname: "w-5",
        formatter: () => <Icon className="size-5" icon={Bars4Icon}/>,
    },
    {
        id: "product",
        label: {displayName: intl.formatMessage({id: "product"})},
        primary: true,
        formatter: (product: ProductReference | null) => product === null
            ? (
                <Badge
                    color={"danger"}
                    size={"xs"}
                    indicator={<BadgeIconIndicator icon={ExclamationCircleIcon}/>}
                >
                    <FormattedMessage id={"doesNotExistAnymore"}/>
                </Badge>
            )
            : product.name,
    },
    {
        id: "description",
        label: {displayName: intl.formatMessage({id: "description"})},
        primary: false,
        formatter: (description: string) => <DescriptionFormatter description={description}/>,
        visibility: "md",
    },
    {
        id: "productExternalId",
        label: {
            displayName: intl.formatMessage({id: "view"}),
            hide: true,
        },
        primary: false,
        sortingConfig: {
            enabled: false,
        },
        align: "right",
        formatter: (_, featuredProduct) => (
            <OptionsFormatter
                deleteFeaturedProductState={deleteFeaturedProductState}
                featuredProduct={featuredProduct}
            />
        ),
    },
]);